export class PageBuilderOptions{
    containerId:string="";
    formsContainerId:string="";
    debugContainerId:string="";
}